module.exports = __webpack_public_path__ + "img/203.23531235.png";